<div id="wrapper">
  <div class="d-flex flex-column" id="content-wrapper">
    <div class="container-fluid">
      <div class="ui-g align-justify">
        <div class="ui-g-12 form-main-body">
          <app-header-navigation [enabled]="enabled"></app-header-navigation>
        </div>
      </div>
      <div class="user-profile-content">
        <div class="ui-g align-justify">
          <div class="ui-g-12 form-main-body">
            <div class="ui-g form-body">
              <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
                <div class="ui-g" id="form-body-column-1">
                  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column">
                    <app-guest-profile></app-guest-profile>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
